import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import stl from "./RecTrendingCars.module.css";
var RecTrendingCars = function RecTrendingCars(_ref) {
  var similar = _ref.similar;
  var _useTranslation = useTranslation(["web_trend"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.ST_recContainer
  }, /*#__PURE__*/React.createElement("p", null, t("تصفح أيضاً", {
    ts: "web_trend"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.ST_recommendations
  }, similar === null || similar === void 0 ? void 0 : similar.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("a", {
      key: idx,
      className: stl.ST_singleRec,
      href: createUrl("/trend/".concat(item.perma_link))
    }, item.h1_tag);
  }))));
};
export default RecTrendingCars;